var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "login-container" }, [
    _c("div", { staticClass: "login-wrapper" }, [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "login-box" },
        [
          _vm._m(1),
          _c("div", { staticClass: "login-right" }, [
            _c(
              "div",
              { staticClass: "login-card", attrs: { shadow: "hover" } },
              [
                _vm._m(2),
                _c(
                  "el-form",
                  {
                    ref: "loginForm",
                    staticClass: "simple-login-form mt-6",
                    attrs: {
                      model: _vm.loginForm,
                      rules: _vm.loginRules,
                      "auto-complete": "on",
                      "label-position": "left",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "username" } },
                      [
                        _c(
                          "label",
                          {
                            staticClass:
                              "block text-sm font-medium text-gray-500 mb-2",
                            attrs: { for: "username" },
                          },
                          [_vm._v("用户名")]
                        ),
                        _c("el-input", {
                          attrs: {
                            placeholder: "用户名",
                            "prefix-icon": "el-icon-user",
                          },
                          model: {
                            value: _vm.loginForm.username,
                            callback: function ($$v) {
                              _vm.$set(_vm.loginForm, "username", $$v)
                            },
                            expression: "loginForm.username",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "password" } },
                      [
                        _c(
                          "label",
                          {
                            staticClass:
                              "block text-sm font-medium text-gray-500 mb-2",
                            attrs: { for: "password" },
                          },
                          [_vm._v("密码")]
                        ),
                        _c("el-input", {
                          attrs: {
                            type: _vm.passwordType,
                            placeholder: "密码",
                            "prefix-icon": "el-icon-lock",
                            "show-password": "",
                          },
                          model: {
                            value: _vm.loginForm.password,
                            callback: function ($$v) {
                              _vm.$set(_vm.loginForm, "password", $$v)
                            },
                            expression: "loginForm.password",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "otp_code" } },
                      [
                        _c(
                          "label",
                          {
                            staticClass:
                              "block text-sm font-medium text-gray-500 mb-2",
                            attrs: { for: "password" },
                          },
                          [_vm._v("谷歌验证码")]
                        ),
                        _c("el-input", {
                          attrs: {
                            type: _vm.passwordType,
                            placeholder: "谷歌验证码",
                            "prefix-icon": "el-icon-key",
                          },
                          model: {
                            value: _vm.loginForm.otp_code,
                            callback: function ($$v) {
                              _vm.$set(_vm.loginForm, "otp_code", $$v)
                            },
                            expression: "loginForm.otp_code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "login-btn",
                        attrs: { loading: _vm.loading, type: "primary" },
                        nativeOn: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.handleLogin.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v(" 登录 ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "OTP code",
                visible: _vm.otpDialogVisible,
                width: "400px",
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                "show-close": false,
                center: "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.otpDialogVisible = $event
                },
              },
            },
            [
              _c("div", { staticClass: "otp-dialog-content text-center" }, [
                _c("div", { staticClass: "qrcode-container" }, [
                  _c("img", {
                    staticStyle: { margin: "0 auto", width: "400px" },
                    attrs: { src: _vm.otpQrCode },
                  }),
                ]),
                _c("div", { staticClass: "otp-info mt-4" }, [
                  _c("div", { staticClass: "warning-text text-danger" }, [
                    _c("i", { staticClass: "el-icon-warning" }),
                    _c("span", [
                      _vm._v("请务必扫码记录此OTP码，用于后续登录验证！"),
                    ]),
                  ]),
                ]),
              ]),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleOtpRecorded },
                    },
                    [_vm._v("继续登录")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "system-title" }, [
      _c("h1", { staticClass: "inline-block" }, [_vm._v("AP Gaming")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "login-left" }, [
      _c("img", {
        staticClass: "login-image",
        attrs: { src: require("@/assets/login/theme.jpg"), alt: "登录背景" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "logo-container text-center" }, [
      _c("img", {
        staticStyle: { width: "80px" },
        attrs: { src: require("@/assets/ap-logo.png") },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }